import React from 'react'
import "./serviceGallery.css"
import { Data } from "./Data.jsx"
import WavesAnimation from '../waves/wavesanimation.jsx'
//Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

//Import Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/autoplay'; // Asegúrate de importar el CSS para autoplay

//Import required modules
import { Pagination, Autoplay } from 'swiper/modules';

const ServiceGallery = () => {
  return (
    <section className="servicegallery" id="servicegallery">
    
    <Swiper className="servicegallery__container"
    loop={true}
    grabCursor={true}
    slidesPerView={3}
    spaceBetween={20}
    autoplay={{
      delay: 4000, // Tiempo en milisegundos antes de cambiar al siguiente slide
      disableOnInteraction: false // Continuar con autoplay después de que el usuario interactúe con el swiper
      }}
    pagination={{
     clickable:true,
    }}
    breakpoints={{
      320: {
        slidesPerView: 1, // On very small screens, show 1 item
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2, // On medium screens, show 2 items
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3, // On large screens, show 3 items
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 4, // On extra large screens, show 4 items
        spaceBetween: 40,
      }
     }}
    modules={[Pagination, Autoplay]}
    >
     {Data.map(({id, image, title, description }) =>{
       return (
         <SwiperSlide className='servicegallery__card' key={id}>
          <div className='service__container'>
           <img src={image} alt="" className='servicegallery__img'/>
           <div className='service__div__title'>{title}</div>
           </div>
         </SwiperSlide>
       )
     })}
    </Swiper>

  </section>
  )
}

export default ServiceGallery
